export default {"src":"https://app.iconosquare.com/_next/static/media/getapp-logo.1703ad2f.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};